var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28,
    height: 16,
    rx: 4,
    fill: "#4285F4",
    fillOpacity: 0.18000000715255737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8448,0.630263Q2.27001,0.358311,2.74945,0.200511Q3.22888,0.0427103,3.73249,0.00895503L3.79937,1.00672Q3.03174,1.05817,2.3836,1.4727L1.8448,0.630263ZM0,4L1,4Q1,3.23392,1.3673,2.56163L0.489737,2.08218Q0.248735,2.52329,0.124368,3.01032Q0,3.49734,0,4ZM0,8L0,6L1,6L1,8L0,8ZM0.147289,13.0755Q1.1732e-15,12.5478,0,12L0,10L1,10L1,12Q1,12.4109,1.11047,12.8066L0.147289,13.0755ZM2.83902,15.8278Q2.35602,15.6813,1.92455,15.4194Q1.49309,15.1576,1.1402,14.7967L1.85515,14.0975Q2.39305,14.6476,3.12926,14.8709L2.83902,15.8278ZM6.81909,16L4.81909,16L4.81909,15L6.81909,15L6.81909,16ZM10.8191,16L8.81909,16L8.81909,15L10.8191,15L10.8191,16ZM14.8191,16L12.8191,16L12.8191,15L14.8191,15L14.8191,16ZM18.8191,16L16.8191,16L16.8191,15L18.8191,15L18.8191,16ZM22.8191,16L20.8191,16L20.8191,15L22.8191,15L22.8191,16ZM26.5941,15.0447Q26.2107,15.3714,25.7582,15.5929Q25.3058,15.8143,24.8125,15.9166L24.6094,14.9375Q25.3612,14.7815,25.9456,14.2836L26.5941,15.0447ZM28,11.4539L28,12Q28,12.7356,27.7383,13.4231L26.8037,13.0673Q27,12.5517,27,12L27,11.4539L28,11.4539ZM28,7.45393L28,9.45393L27,9.45393L27,7.45393L28,7.45393ZM27.9633,3.45935Q28,3.72843,28,4L28,5.45393L27,5.45393L27,4.00001Q27,3.79633,26.9725,3.5945L27.9633,3.45935ZM25.6738,0.367035Q26.1319,0.578118,26.5233,0.896338Q26.9148,1.21456,27.2149,1.61999L26.4112,2.21499Q25.9537,1.59702,25.2553,1.27528L25.6738,0.367035ZM21.727,0L23.727,0L23.727,1L21.727,1L21.727,0ZM17.727,0L19.727,0L19.727,1L17.727,1L17.727,0ZM13.727,0L15.727,0L15.727,1L13.727,1L13.727,0ZM9.72696,0L11.727,0L11.727,1L9.72696,1L9.72696,0ZM7.72696,0L7.72696,1L5.72696,1L5.72696,0L7.72696,0Z",
    fillRule: "evenodd",
    fill: "#4285F4",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThird);
export default __webpack_public_path__ + "static/media/icon-third.2ab29e19da278094f9facdfa2fef21d6.svg";
export { ForwardRef as ReactComponent };